import { request } from '../../utility/services/request';
import { Service } from '../base';

class ConsultasService extends Service {
	filter(
		consulta_id,
		params = {
			page: null,
			per_page: '',
			orderBy: '',
			order: '',
			params: ''
		}
	) {
		return request(
			'GET',
			`${this.baseUrl}/${consulta_id}?page=${params?.page || ''}
				${params.per_page ? `&per_page=${params.per_page}` : ''}
				${params.orderBy ? `&orderBy=${params.orderBy}` : ''}
				${params.order ? `&order=${params.order}` : ''}
				${params.params ? `&params=${JSON.stringify(params.params)}` : ''}
			`
		);
	}

	consultaFamiliar(
		params = {
			page: null,
			per_page: '',
			orderBy: '',
			order: '',
			params: ''
		}
	) {
		return request(
			'GET',
			`${this.baseUrl}?page=${params?.page || ''}
				${params.per_page ? `&per_page=${params.per_page}` : ''}
				${params.orderBy ? `&orderBy=${params.orderBy}` : ''}
				${params.order ? `&order=${params.order}` : ''}
				${params.params ? `&params=${JSON.stringify(params.params)}` : ''}
			`
		);
	}

	marcarPositiva(consulta_id, ficha_id) {
		return request(
			'GET',
			`${this.baseUrl}/${consulta_id}/${ficha_id}/positiva`
		);
	}

	getFicha(consulta_id, ficha_id) {
		return request(
			'GET',
			`${this.baseUrl}/${consulta_id}/ver-ficha/${ficha_id}`
		);
	}
}

export default ConsultasService;
